
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Form } from "@/components/ui/form";
import { AppointmentFormFields } from "./form/AppointmentFormFields";
import { AppointmentFormActions } from "./form/AppointmentFormActions";
import { useAppointmentForm } from "./form/useAppointmentForm";
import { ScrollArea } from "@/components/ui/scroll-area";

interface AppointmentFormProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: () => void;
}

export const AppointmentForm = ({ open, onOpenChange, onSuccess }: AppointmentFormProps) => {
  const { form, isLoading, onSubmit } = useAppointmentForm(val => {
    onOpenChange(val);
    if (val === false && onSuccess) {
      onSuccess();
    }
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px] w-[95vw] sm:w-full h-[90vh]">
        <DialogHeader>
          <DialogTitle>Nouveau rendez-vous</DialogTitle>
        </DialogHeader>
        <ScrollArea className="h-[60vh] pr-4">
          <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
              <AppointmentFormFields form={form} />
              <AppointmentFormActions
                onCancel={() => onOpenChange(false)}
                isLoading={isLoading}
              />
            </form>
          </Form>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
